import React from 'react';
import { logoAppStore } from '../../../../assets/images';
import Image from 'next/image';

interface LogoAppStoreProps {
  sizeClassname?: string;
}

const LogoAppStore = ({ sizeClassname = '' }: LogoAppStoreProps) => {
  return (
    <>
      <Image
        className={`h-[42.73px] w-auto lg:h-[48px] lg:w-[157px] ${sizeClassname}`}
        width={500}
        height={500}
        src={logoAppStore.src}
        alt="logo App Store"
        sizes="(min-width: 380px) 147px, calc(35vw + 21px)"
      />
    </>
  );
};

export default LogoAppStore;
